import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const Quote = {
  getQuotes: () =>
    request.get("/qoute", {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateQuoteById: (id, data) =>
    request.patch(`/quote/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default Quote;
